import { oc } from '@orpc/contract';
import { policyInputCatalogOutputSchema } from '../schemas/policies.schemas.js';
/** Every name an equation may read, with its unit and where the value comes from (plan §5.2). */
export const getPolicyInputCatalogContract = oc
    .route({
    method: 'GET',
    path: '/policies/inputs',
    tags: ['Policies'],
    summary: 'The catalogue of inputs available to the equations',
})
    .output(policyInputCatalogOutputSchema);
//# sourceMappingURL=get-policy-input-catalog.contract.js.map